import { render } from "./Navigation.vue?vue&type=template&id=2d0f8d02&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=2d0f8d02&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\cgproject\\canggu-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0f8d02"]])

export default __exports__